module.exports = __webpack_public_path__ + "static/assets/4b46c412a2374446d73a9358ac14396e.png";